import { render } from "./enrolment-review-modal.vue?vue&type=template&id=1eb6d3a5&ts=true"
import script from "./enrolment-review-modal.ts?vue&type=script&lang=ts&external"
export * from "./enrolment-review-modal.ts?vue&type=script&lang=ts&external"

import "./enrolment-review-modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__